export default __webpack_public_path__ + "1ba043ba43728e466e526a056b530e1b.ttf";